import React from 'react';
import { useFakeToggleState } from '@wix/da-hooks/pkg/useFakeToggleState';
import MainToggle from '@wix/da-ds/pkg/formControls/dsPresets/MainToggle';
var MatureToggle = function (_a) {
    var id = _a.id, _b = _a.value, value = _b === void 0 ? false : _b, onChange = _a.onChange, size = _a.size, ariaLabel = _a["aria-label"], ariaLabelledBy = _a["aria-labelledby"];
    var _c = useFakeToggleState(value, onChange), onClick = _c.onClick, toggleState = _c.toggleState;
    return (React.createElement(MainToggle, { id: id, value: toggleState, onChange: onClick, size: size, "aria-label": ariaLabel, "aria-labelledby": ariaLabelledBy }));
};
export default MatureToggle;
//# sourceMappingURL=MatureToggle.js.map